import React from 'react';
import { get } from 'lodash'

import { withCars } from '../../../shared/containers/containerCars'
import { withFilterCars } from '../../../shared/containers/containerFilterCars'

import Pagination from '../../../shared/items/contols/pagination'

const CarsPaginationWrapper = props => {
  const { onHandleChangeStore, filterCarsListItems, filterCountUnits } = props

  return get(filterCarsListItems, ["count"], 0) <= filterCountUnits
    ? <Pagination
      totalCount={filterCountUnits}
      count={get(filterCarsListItems, ["count"], 0)}
      page={get(filterCarsListItems, ["page"], 0)}
      onHandleChangeStore={onHandleChangeStore.bind(this, 'page')}
    />
    : null
}

export default withCars(withFilterCars(React.memo(CarsPaginationWrapper)))


